import { render, staticRenderFns } from "./NMBRActionsWrapper.form.vue?vue&type=template&id=77dab7c0&scoped=true&"
import script from "./NMBRActionsWrapper.form.vue?vue&type=script&lang=js&"
export * from "./NMBRActionsWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./NMBRActionsWrapper.form.vue?vue&type=style&index=0&id=77dab7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dab7c0",
  null
  
)

export default component.exports